import React from 'react';
import classNames from 'classnames';
import { IPageTextProps } from './PageText.types';
import styles from './PageText.module.css';

export const PageText: React.FC<IPageTextProps> = ({ children, className, variant }: IPageTextProps) => {
  return <p className={classNames(styles.pageText, className, variant && styles[variant])}>{children}</p>;
};
